var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconResumsWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86.792,
    height: 106.277,
    viewBox: "0 0 86.792 106.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1979",
    "data-name": "Ret\\xE2ngulo 1979",
    width: 86.789,
    height: 106.273,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09d785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098caf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1980",
    "data-name": "Ret\\xE2ngulo 1980",
    width: 86.792,
    height: 106.277,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-resums-white",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4068",
    "data-name": "Grupo 4068",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4067",
    "data-name": "Grupo 4067",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1847",
    "data-name": "Caminho 1847",
    d: "M50.184,50.917h-22c-1.33,0-2.152-.542-2.4-1.541a2.054,2.054,0,0,1,1.438-2.524,2.076,2.076,0,0,1,.4-.068,9,9,0,0,1,.934-.014H71.838a7.549,7.549,0,0,1,1.036.026,2.066,2.066,0,0,1,.036,4.091,6.851,6.851,0,0,1-1.035.032H50.184",
    transform: "translate(-1.294 -2.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1848",
    "data-name": "Caminho 1848",
    d: "M50.15,61.409H28.563a6.819,6.819,0,0,1-1.14-.041,2.068,2.068,0,0,1,.031-4.074,5.875,5.875,0,0,1,.932-.033H71.98a7.1,7.1,0,0,1,.829.019,2.066,2.066,0,0,1-.031,4.113,8.5,8.5,0,0,1-.934.017H50.15",
    transform: "translate(-1.294 -2.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1849",
    "data-name": "Caminho 1849",
    d: "M50.244,67.747H71.831a7.861,7.861,0,0,1,1.036.025,2.066,2.066,0,0,1,.051,4.09,6.612,6.612,0,0,1-1.035.033H28.5a6.612,6.612,0,0,1-1.035-.033,2.068,2.068,0,0,1,.05-4.091,7.7,7.7,0,0,1,1.036-.025H50.244",
    transform: "translate(-1.294 -3.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1850",
    "data-name": "Caminho 1850",
    d: "M50.252,78.237H71.839a7.549,7.549,0,0,1,1.036.026,2.066,2.066,0,0,1,.036,4.091,6.852,6.852,0,0,1-1.035.032H28.494a6.5,6.5,0,0,1-1.035-.034,2.068,2.068,0,0,1,.066-4.09,8.029,8.029,0,0,1,1.036-.025H50.252",
    transform: "translate(-1.294 -3.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1851",
    "data-name": "Caminho 1851",
    d: "M54.771,40.427H37.446A8.028,8.028,0,0,1,36.41,40.4a2.064,2.064,0,0,1,0-4.1,6.36,6.36,0,0,1,.829-.022H72.51a6.166,6.166,0,0,1,.726.017,2.066,2.066,0,0,1,0,4.113,8.261,8.261,0,0,1-.933.018Z",
    transform: "translate(-1.739 -1.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1852",
    "data-name": "Caminho 1852",
    d: "M89.03,61.4a2.069,2.069,0,1,1,2.111-2.025V59.4a2.09,2.09,0,0,1-2.11,2",
    transform: "translate(-4.373 -2.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1853",
    "data-name": "Caminho 1853",
    d: "M27.806,36.285a2.069,2.069,0,1,1-2.08,2.057c0-.016,0-.033,0-.049a2.065,2.065,0,0,1,2.079-2.008",
    transform: "translate(-1.294 -1.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1854",
    "data-name": "Caminho 1854",
    d: "M64.282,11.209C63.573,19,66.837,22.518,73.4,22.474h9.227V45.443c0,.934-.043,1.871.021,2.8a2.058,2.058,0,0,0,2.082,1.91,2.107,2.107,0,0,0,2.026-1.873,5.039,5.039,0,0,0,.018-.622q-.02-13.439.014-26.878a3.146,3.146,0,0,0-1.06-2.367Q77.217,9.906,68.693,1.4C68.185.9,67.6.466,67.055,0H16.4c-4.08,1.525-5.194,3.134-5.188,7.519v3.688c-1.658,0-3.206-.01-4.755,0-.176-.007-.351-.007-.527,0A6.215,6.215,0,0,0,.007,17.7Q0,58.744.01,99.791c-.008.169-.008.337,0,.506a6.222,6.222,0,0,0,6.459,5.975c1.834.009,3.667,0,5.5,0q28.336.011,56.672-.012a9.328,9.328,0,0,0,2.558-.3,6.128,6.128,0,0,0,4.358-5.817c.031-1.678.006-3.357.006-5.079h4.406c4.227,0,6.807-2.562,6.807-6.766V65.674a7.641,7.641,0,0,0-.023-.933,2.065,2.065,0,0,0-4.1-.017,8.027,8.027,0,0,0-.025,1.036V88.175c0,2.051-.686,2.735-2.737,2.735H18.13c-2.109,0-2.766-.668-2.766-2.81V6.947c0-2.142.65-2.8,2.778-2.8h46.14ZM18.215,95.062H71.4c0,1.82.054,3.542-.021,5.258a1.971,1.971,0,0,1-1.867,1.784,8.746,8.746,0,0,1-.934.016H7.032c-2.263,0-2.878-.626-2.878-2.905V18.284c0-2.332.6-2.925,2.96-2.925h4.1v72.72c0,4.5,2.492,6.984,7,6.984M79.142,18.238c-2.329,0-4.915.089-7.492-.031a3.425,3.425,0,0,1-3.117-3.348c-.06-2.487-.015-4.972-.015-7.236L79.143,18.235Z",
    transform: "translate(-0.002 0)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4070",
    "data-name": "Grupo 4070",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4069",
    "data-name": "Grupo 4069",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1855",
    "data-name": "Caminho 1855",
    d: "M70.289,22.323c-.015.021-.032.04-.048.061a.9.9,0,0,1,.287.6c.046.649.016,1.3.016,2.027H29.92V16.035H65.659l0,.01.015-.008a16.541,16.541,0,0,1-.1-4.237H28.341c-1.925,0-2.633.693-2.633,2.623q-.011,6.07,0,12.142c0,1.993.692,2.668,2.694,2.668H72c1.978,0,2.685-.7,2.7-2.678.007-1.159,0-2.317,0-3.489a11.25,11.25,0,0,1-4.407-.745",
    transform: "translate(-1.291 -0.593)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResumsWhite);
export default __webpack_public_path__ + "static/media/icon-resums-white.6bccfe8ff17d4fceff1d116cea535675.svg";
export { ForwardRef as ReactComponent };